export default "__VITE_ASSET__SU1UHE$i__"